const PREFIX = 'model-lineup';

export const SPARTAN_LINEUP_TRACKING = {
  section: PREFIX,
  carouselViewport: `${PREFIX}-carousel-viewport`,
  modelList: `${PREFIX}-model-list`,
  groupTabs: `${PREFIX}-group-tabs`,
  groupIndicator: `${PREFIX}-group-indicator`,
  groupTab: (index: number) => `${PREFIX}-group-tab-${index + 1}`,
  groupPanel: `${PREFIX}-group-panel`,
  model: (index: number) => `${PREFIX}-model-${index + 1}`,
  modelTitle: (index: number) => `${PREFIX}-model-${index + 1}-title`,
  modelImage: (index: number) => `${PREFIX}-model-${index + 1}-image`,
  modelImageBackground: (index: number) =>
    `${PREFIX}-model-${index + 1}-image-background`,
  modelImageLink: (index: number) => `${PREFIX}-model-${index + 1}-image-link`,
  modelStartPrice: (index: number) =>
    `${PREFIX}-model-${index + 1}-start-price`,
  modelEngine: (index: number) => `${PREFIX}-model-${index + 1}-engine`,
  modelEngineTitle: (index: number) =>
    `${PREFIX}-model-${index + 1}-engine-title`,
  modelEngineTabs: (index: number) =>
    `${PREFIX}-model-${index + 1}-engine-tabs`,
  modelEnginePanel: (index: number) =>
    `${PREFIX}-model-${index + 1}-engine-panel`,
  modelEngineTabItem: (index: number) =>
    `${PREFIX}-model-${index + 1}-engine-tab`,
  modelEngineSpecList: (index: number) =>
    `${PREFIX}-model-${index + 1}-engine-spec-list`,
  modelEngineSpec: (modelIndex: number, specIndex: number) =>
    `${PREFIX}-model-${modelIndex + 1}-engine-spec-${specIndex + 1}`,
  modelEngineSpecLabel: (modelIndex: number, specIndex: number) =>
    `${PREFIX}-model-${modelIndex + 1}-engine-spec-${specIndex + 1}-label`,
  modelEngineSpecValue: (modelIndex: number, specIndex: number) =>
    `${PREFIX}-model-${modelIndex + 1}-engine-spec-${specIndex + 1}-value`,
  modelEngineSpecUnit: (modelIndex: number, specIndex: number) =>
    `${PREFIX}-model-${modelIndex + 1}-engine-spec-${specIndex + 1}-unit`,
  modelEngineRemark: (index: number) =>
    `${PREFIX}-model-${index + 1}-engine-remark`,
  modelCta: (index: number) => `${PREFIX}-model-${index + 1}-cta`,
  detailButton: (index: number) => `${PREFIX}-model-${index + 1}-detail-button`,
  compareButton: (index: number) =>
    `${PREFIX}-model-${index + 1}-compare-button`,
  pagination: `${PREFIX}-pagination`,
  paginationItem: `${PREFIX}-pagination-item`,
  sliderNav: `${PREFIX}-slider-nav`,
  sliderNavPrev: `${PREFIX}-slider-nav-prev`,
  sliderNavNext: `${PREFIX}-slider-nav-next`,
  remark: `${PREFIX}-remark`,
} as const;

export const SPARTAN_LINEUP_DATA_GA = {
  section: PREFIX,
} as const;
